<template>
  <div class="input-phone">
    <InputItem
      :id="`${id}_1`"
      v-model="phoneValue.phone1"
      :maxlength="isMobile ? 3 : 6"
      :tracking-name="`${trackingName}_1`"
      type="text"
      class="-xs"
      :tabindex="tabindex1"
    />
    <InputAppend class="-xs">ー</InputAppend>
    <InputItem
      :id="`${id}_2`"
      v-model="phoneValue.phone2"
      :maxlength="4"
      :tracking-name="`${trackingName}_2`"
      type="text"
      class="-xs"
      :tabindex="tabindex2"
    />
    <InputAppend class="-xs">ー</InputAppend>
    <InputItem
      :id="`${id}_3`"
      v-model="phoneValue.phone3"
      :maxlength="4"
      :tracking-name="`${trackingName}_3`"
      type="text"
      class="-xs"
      :tabindex="tabindex3"
    />
  </div>
</template>

<script>
import InputItem from "./InputItem";
import InputAppend from "./InputAppend";
export default {
  name: "InputPhone",
  components: { InputAppend, InputItem },
  props: {
    phone: {
      type: Object,
      default: () => ({
        phone1: "",
        phone2: "",
        phone3: "",
      }),
    },
    tabindex1: { type: String, default: "" },
    tabindex2: { type: String, default: "" },
    tabindex3: { type: String, default: "" },
    id: {
      type: String,
      default: "phone",
    },
    trackingName: { type: String, default: "" },
    isMobile: { type: Boolean, default: false },
  },
  emits: ["input", "change"],
  data() {
    return {
      phoneValue: {},
    };
  },
  watch: {
    phone: {
      handler(n) {
        if (
          this.phoneValue.phone1 !== n.phone1 ||
          this.phoneValue.phone2 !== n.phone2 ||
          this.phoneValue.phone3 !== n.phone3
        )
          this.phoneValue = { ...n };
      },
      deep: true,
      immediate: true,
    },
    phoneValue: {
      handler(n) {
        this.$emit("input", n);
        this.$emit("change", n);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.input-phone {
  @include flex(flex, flex-start, center, row, nowrap);
}
</style>
